import { Box, Divider, List, Typography, LinearProgress } from "@mui/material";
import { ccyFormat } from "../../../helpers/helper";

const Money = ({ loading, readonly = false, money = {} }) => {
  const deposito = Number(money?.deposito || 0)

  const byType = Object.entries(money || {}).reduce((acc, [key, val]) => {
    if (key === 'deposito') return acc
    const match = key.match(/^(.+)_(m|t)$/)
    if (!match) return acc
    const name = match[1]
    if (!acc[name]) acc[name] = { morning: 0, afternoon: 0 }
    if (match[2] === 'm') acc[name].morning += Number(val || 0)
    else acc[name].afternoon += Number(val || 0)
    return acc
  }, {})

  const totalSums = Object.values(byType).reduce((s, t) => s + t.morning + t.afternoon, 0)
  const totalWithDeposit = totalSums + deposito

  return loading ? <LinearProgress /> : <><List sx={{ overflowY: 'auto', width: '100%', paddingY: 2, paddingX: 0, background: 'transparent' }} >
  </List>
    <Box display='flex' flexDirection='row' justifyContent='space-between'>
      <Typography variant="subtitle2">
        {`Total medios de pago`}
      </Typography>
      <Typography variant="subtitle2">
        {totalSums ? `$ ${ccyFormat(totalSums)}` : ccyFormat(0)}
      </Typography>
    </Box>
    {Object.entries(byType).map(([name, data]) => {
      const total = data.morning + data.afternoon
      return (
        <Box key={name} display='flex' flexDirection='row' justifyContent='space-between'>
          <Typography variant="subtitle2">
            {name.charAt(0).toUpperCase() + name.slice(1)}
          </Typography>
          <Typography variant="subtitle2">
            {total ? `$ ${ccyFormat(total)}` : ccyFormat(0)}
          </Typography>
        </Box>
      )
    })}
    <Box display='flex' flexDirection='row' justifyContent='space-between'>
      <Typography variant="subtitle2">
        {`Señas / Reservas`}
      </Typography>
      <Typography variant="subtitle2">
        {deposito ? `$ ${ccyFormat(deposito)}` : ccyFormat(0)}
      </Typography>
    </Box>
    <Divider sx={{ my: 1 }} />
    <Box display='flex' flexDirection='row' justifyContent='space-between'>
      <Typography variant="subtitle1" fontWeight={700}>
        {`TOTAL GENERAL`}
      </Typography>
      <Typography variant="subtitle1" fontWeight={700}>
        {totalWithDeposit ? `$ ${ccyFormat(totalWithDeposit)}` : ccyFormat(0)}
      </Typography>
    </Box>
  </>
}


export default Money;